export default __webpack_public_path__ + "static/media/slider4.5b860d6d.jpg";